import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

/**
 * @param {string} question
 */
export async function fetchRegionalCalendarAnswer(question) {
  const headers = await authHeaders();
  const params = new URLSearchParams({ q: question });
  const res = await fetch(`${API_BASE}/api/regional-calendar?${params}`, {
    headers,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Anfrage fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * School-pack dates for the agenda (60 days) and the Ferien/Feiertage
 * already spoken in «Was steht an?».
 */
export async function fetchSchoolAgendaDates() {
  const headers = await authHeaders();
  const params = new URLSearchParams({ horizon: "60" });
  const res = await fetch(`${API_BASE}/api/regional-calendar?${params}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return {
    schoolDates: Array.isArray(data.schoolDates) ? data.schoolDates : [],
    nearHolidays: Array.isArray(data.nearHolidays) ? data.nearHolidays : [],
  };
}

export async function fetchRegionalCalendarContext() {
  const headers = await authHeaders();
  const params = new URLSearchParams({ horizon: "14" });
  const res = await fetch(`${API_BASE}/api/regional-calendar?${params}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}
